import React from 'react';

import styles from './Wrapper.module.css'
import {cn} from "../../../utils/cn.ts";

type BackgroundColors = '#182128' | '#eee' | '#e3e3e3';

interface Props {
    bgColor?: BackgroundColors
    containerClassName?: string
    children: React.ReactNode
}

export const Wrapper: React.FC<Props> = ({bgColor, containerClassName, children}) => {
    return (
        <div className={styles.wrapper} style={{backgroundColor: bgColor}}>
            <div className={cn(styles.container, containerClassName)}>
                {children}
            </div>
        </div>
    );
};